// T017 — Transaction-type label/tone/icon mapping. Centralised so the audit-log
// filter (US4) and the table renderer share one definition.
import type { WalletTransactionType } from "../../types/wallet";

interface TransactionTypeMeta {
  label: string;
  severity: "success" | "info" | "warning" | "danger" | undefined;
  icon: string;
}

export const TRANSACTION_TYPE_META: Record<WalletTransactionType, TransactionTypeMeta> = {
  issuance: { label: "Issued", severity: "success", icon: "pi pi-plus-circle" },
  spend: { label: "Spent", severity: "info", icon: "pi pi-bolt" },
  refund_return: { label: "Refund", severity: "info", icon: "pi pi-replay" },
  expiration: { label: "Expired", severity: undefined, icon: "pi pi-clock" },
  admin_issue: { label: "Admin issued", severity: "success", icon: "pi pi-user-plus" },
  admin_revoke: { label: "Admin revoked", severity: "danger", icon: "pi pi-user-minus" },
  forfeiture: { label: "Forfeited", severity: undefined, icon: "pi pi-times-circle" },
};

export const ADMIN_ACTION_TYPES: WalletTransactionType[] = ["admin_issue", "admin_revoke"];

export const isAdminActionType = (type: WalletTransactionType): boolean =>
  ADMIN_ACTION_TYPES.includes(type);

// Programs seen on credit batches. Unknown values fall back to the raw string
// so a new program still shows up, just unlabelled.
export const SOURCE_PROGRAM_LABELS: Record<string, string> = {
  referrals: "Referral",
  "referrals-manual": "Referral (manual)",
  admin: "Admin",
};

export const sourceProgramLabel = (program: string | null | undefined): string | null =>
  program ? SOURCE_PROGRAM_LABELS[program] ?? program : null;
